// extracted by mini-css-extract-plugin
export default {"root":"EntityPageHeaderLayout_root__Xstzf","left":"EntityPageHeaderLayout_left__PgloD","center":"EntityPageHeaderLayout_center__P458A","right":"EntityPageHeaderLayout_right__YLJDm"};